import { Box, Button, Divider, TextField } from '@mui/material';
import type { ReactElement } from 'react';

import type { FilterType } from '../../../utils/ApiClient';

interface Props {
  filterValues: FilterType[];
  onFilterChange: (values: FilterType[]) => void;
  onFilterClear: () => void;
}

export const NumericColumnFilter = ({
  filterValues,
  onFilterChange,
  onFilterClear,
}: Props): ReactElement => (
  <Box display='flex' flexDirection='column' alignItems='center' flexWrap='nowrap'>
    <Box display='flex' flexDirection='column' gap='1rem' width='100%'>
      <TextField
        label='From Value'
        type='number'
        value={filterValues[0]}
        onChange={(e) => onFilterChange([e.target.value, filterValues[1]])}
        size='small'
        fullWidth
        inputProps={{ inputMode: 'numeric' }}
      />
      <TextField
        label='To Value'
        type='number'
        value={filterValues[1]}
        onChange={(e) => onFilterChange([filterValues[0], e.target.value])}
        size='small'
        fullWidth
        inputProps={{ inputMode: 'numeric' }}
      />
    </Box>
    <Divider sx={{ width: '100%', marginY: 2 }} />
    <Box display='flex' width='100%' justifyContent='flex-end'>
      <Button onClick={onFilterClear} size='small'>
        Clear
      </Button>
    </Box>
  </Box>
);
